<div menuSystem [cerrixTab]="tab">
    <div [attr.name]="'Workday Organizer'" menuicon="fa-calendar-check fas" menusystemsubmenu>
        <holidays-daysoff
            [holidaysDaysOff]="holidaysDaysOff"
            (isDirtyChange)="holidaysDirty = $event"
        ></holidays-daysoff>
        <working-days
            [workingDays]="workingDays"
            (isDirtyChange)="workingDays = $event; workingDaysDirty = true"
        ></working-days>
        <cerrix-page-footer>
            <cerrix-button
                class="save-organizer"
                buttonType="secondary"
                secondaryColor="outlined"
                buttonSize="medium"
                [waitingOnResult]="savingOrganizer"
                [showResultText]="organizerSaved"
                [disabled]="!workingDaysDirty && !holidaysDirty"
                (click)="saveOrganizer()"
                ><span button-text>Save</span
                ><span result-text>Saved! <i class="fa-solid fa-check"></i></span
            ></cerrix-button>
        </cerrix-page-footer>
    </div>
</div>
